export default __webpack_public_path__ + "static/media/O-092.cfd7a0d2.png";